var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-icon", class: "page-icon-" + _vm.size },
    [
      _c(
        "span",
        {
          class:
            "container-" + (_vm.image && _vm.image.length ? "" : _vm.color),
          style: { backgroundImage: _vm.image, backgroundPosition: "center" }
        },
        [!_vm.image ? [_vm._v(_vm._s(_vm.text))] : _vm._e()],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }